import { Auth } from 'firebase/auth';
import useFetchImplementation from '@components/shared/useFetchImplementation';
import getOmsUrl from '@utils/getOmsUrl';

export default function useAuthFetch(firebaseAuth: Auth | null | undefined, klavioKey?: string) {
  const omsUrl = getOmsUrl() ?? '';

  return useFetchImplementation(firebaseAuth, omsUrl, klavioKey);
}
